<template>
  <div class="login-container">
    <!-- 修改服务器地址 -->
    <!-- <transition name="animation"> -->
    <div class="login-localhost" v-if="showType == 'host'">
      <span class="exit" @click="showType = 'login'">
        <i class="el-icon-circle-close"></i>
      </span>
      <div class="localhost-input">
        <div class="localhost-input-item">
          <el-input placeholder="请输入服务器地址" v-model="localhost">
            <template slot="prepend">http://</template>
          </el-input>
        </div>
        <div class="localhost-input-item">
          <el-button type="primary" @click="entrance">进 入</el-button>
        </div>
      </div>
      <div class="localhost-status">
        <div>{{connectionStatus}}</div>
        <div>
          <span>历史访问记录</span>
          <span style="padding-left: 24px; color: #2fb3ff;" @click="remHistoryLocalhost">清除</span>
          <ul style="padding-top: 6px;">
            <li class="l-h-list" v-for="(item, index) in historyLocalhost" :key="index" v-show="index < 4" @click="handleHistory(item)">{{item}}</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- </transition> -->
    <!-- 登录主界面 -->
    <!-- <transition name="animation"> -->
    <div class="login" v-if="showType == 'login'">
      <div class="language flex-c-c">
        <div class="flex-c-c">
          <el-dropdown @visible-change="(val) => visibleChange = val" @command="languageChanged">
            <span class="el-dropdown-link flex-c-c">
              <img v-if="!visibleChange" src="@/assets/images/home/language.png" class="icon language-icon" style alt />
              <img v-else src="@/assets/images/home/language_sel.png" class="icon language-icon" style alt />
              <span style="margin: 0px 8px; color: #606266; font-size: 16px;">{{languageList[$cookies.get("language")]}}</span>
              <!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="key" v-for="(value, key) in languageList" :key="key">{{value}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="$cookies.get('showHelp') == '1'">
          |
          <a :href="$cookies.get('helpUrl')" target="_blank" style="text-decoration: none;">
            <span style="margin: 0px 8px; color: #606266; font-size: 16px;">{{$t('login.helpDocument')}}</span>
          </a>
        </div>
      </div>
      <div class="login-main">
        <div class="main-left">
          <div class="left-title">
            <img :src="`${companyPicPath}company_background.png`" alt />
          </div>
        </div>
        <div class="main-right">
          <el-form :model="loginForm" :rules="rules" ref="loginForm">
            <el-form-item class="form-login">
              <div class="login-img">
                <img class="login-img" :src="`${companyPicPath}company_loginLogo.png`" alt />
              </div>
            </el-form-item>
            <el-form-item prop="username" class="form-item">
              <el-input class="item-input" :placeholder="$t('login.account')" auto-complete="off" v-model="loginForm.username" clearable></el-input>
            </el-form-item>
            <el-form-item prop="password" class="form-item">
              <el-input class="item-input" :placeholder="$t('login.password')" auto-complete="off" :type="pwdType" v-model="loginForm.password" @keyup.enter.native="handleSubmit('loginForm')">
                <template slot="suffix">
                  <span class="password-eye" style="padding: 14px 20px;" @click="showPassword" :class="eyeType"></span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="vcode" class="form-verify" v-if="showVerify">
              <div class="verify">
                <el-input v-model="loginForm.vcode" :placeholder="$t('login.verification')" class="identifyinput" clearable @keyup.enter.native="handleSubmit('loginForm')"></el-input>
                <div @click="refreshCode" class="verify-code">
                  <img class="identifyimg" :src="verifyUrl" alt />
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" @click="handleSubmit('loginForm')" round>{{$t('login.Login')}}</el-button>
            </el-form-item>
            <el-form-item style="margin-top: 12px;">
              <div class="register">
                <span @click="showType = 'register'">{{$t('login.memberRegister')}}</span>
                <i>&nbsp;|&nbsp;</i>
                <span @click="showType = 'resetPd'">{{$t('login.ForgetThePassword')}}</span>
              </div>
            </el-form-item>
            <el-form-item style="margin-top: 0px">
              <div class="form-rtp">
                <el-checkbox v-model="rtp" size="medium">{{$t('login.NoLogin')}}</el-checkbox>
                <span @click="localhostEdit" style="cursor: pointer;" v-if="false">修改服务器地址</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="record-n-varchar flex-c-c">
        <a href="https://beian.miit.gov.cn/" target="_blank">{{ $cookies.get('icp') }}</a>
      </div>
    </div>
    <!-- 修改密码 -->
    <!-- <transition name="animation"> -->
    <div v-if="showType == 'editPd'">
      <edit-pd @setShowType="setShowType"></edit-pd>
    </div>
    <!-- </transition> -->
    <!-- 注册主界面 -->
    <!-- <transition name="animation"> -->
    <div v-if="showType == 'register'">
      <register @setShowType="setShowType"></register>
    </div>
    <!-- </transition> -->
    <!-- 找回密码 -->
    <!-- <transition name="animation"> -->
    <div v-if="showType == 'resetPd'">
      <reset-pd @setShowType="setShowType"></reset-pd>
    </div>
    <!-- </transition> -->
  </div>
</template>

<script type="text/ecmascript-6">
const baseURL = '/api'; // 与VERIFY_URI组成验证码获取链接，为防止session丢失，需保持与ajax请求域名一致
const VERIFY_URI = "/admin/nindex/verify";
const base = process.env.NODE_ENV === 'production' ? "" : process.env.VUE_APP_IMG;
const companyPicPath = base + "/company/images/";
// console.log(process.env);
import Register from "@/components/login/Register"
import ResetPd from "@/components/login/ResetPd"
import editPd from "@/components/login/editPd"
import passwordStrength from '@/assets/scripts/passwordStrength.js'
const languageList = {
  'zh': '简体中文',
  'en': 'English',
  'vi': 'Vietnamese'
}
export default {
  data() {
    return {
      localhostShow: false,
      showType: "login", //login/register/resetPd/host/editPd
      localhost: "",
      historyLocalhost: [],
      connectionStatus: "等待连接",
      title: "",
      pwdType: "password",
      eyeType: "fa fa-eye-slash fa-lg",
      verifyUrl: "",
      verifyT: "",
      showVerify: false,
      companyPicPath: companyPicPath,
      rtp: false,
      loginForm: {
        username: "",
        password: "",
        vcode: ""
      },
      rules: {// 表单验证规则
        username: [{ required: true, message: "账户不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
        vcode: [{ required: true, message: "验证码输入错误", trigger: "blur" }]
      },
      visibleChange: false,
      languageList
    };
  },
  components: {
    Register,
    ResetPd,
    editPd
  },
  created() {
    // 获取验证码
    this.getRandom();
    // 验证密码输入错误次数，是否显示验证码
    // this.$http.post("/admin/nindex/isLocked", {}, () => { });
    this.showVerify = parseInt(this.$cookies.get('verify')) >= 3;
    // 验证密码是否记住
    this.rtp = this.$cookies.get("rtp") === '1';
    // 如果有记住的密码就自动填充
    this.loginForm = JSON.parse(localStorage.getItem("userInfo")) || this.loginForm;
    // 获取uuid
    if (window.location.search !== "") {
      console.log(1, window.location.search.split("=")[1]);
      localStorage.setItem("uuid", window.location.search.split("=")[1]);
    }
    // console.log(4, window.location);
    // console.log(2, window.location.search);
    // console.log(3, window.location.search.split("=")[1]);

    // 从本地localStorage读取历史地址列表，并跳转到第一个地址
    let historyLocalhost = JSON.parse(localStorage.getItem("historyLocalhost"));
    if (historyLocalhost && historyLocalhost.length > 0) {
      let localUrl = JSON.parse(localStorage.getItem("historyLocalhost"))[0];
      if (window.location.host !== localUrl) {
        window.location.replace(`http://${localUrl}`);
      } else {
        // 从服务器获取历史输入地址
        this.$http.post("/admin/nindex/urlSynchronize", { url_list: "", type: "get", mt_uuid: localStorage.getItem("uuid") }, data => {
          localStorage.setItem("historyLocalhost", JSON.stringify(data.mt_urls));
        });
      }
    } else {
      // url正则表达式
      let reg = new RegExp("^((https|http|ftp|rtsp|mms)?://)");
      if (reg.test(window.location.origin)) {
        this.historyLocalhost.unshift(window.location.host);
        localStorage.setItem("historyLocalhost", JSON.stringify(this.historyLocalhost));
      } else {
        this.showType = 'host';
      }
    }
    // 语言设置
    if (this.$cookies.get("language")) {
      this.$i18n.locale = this.$cookies.get("language");
    } else {
      this.getLanguage();
    }
  },
  mounted() {
    // console.log(navigator.userAgent);
    // navigator.userAgent.indexOf("Chrome") > -1 && this.browserDetection();
    this.browserDetection();
  },
  methods: {
    getLanguage() {
      let language = (navigator.language || navigator.browserLanguage).toLowerCase();
      if (language.indexOf('zh') != -1) {
        // 浏览器语言是中文
        this.languageChanged('zh');
        console.log("浏览器语言是中文" + this.$i18n.locale);
      } else if (language.indexOf('en') != -1) {
        // 浏览器语言是英文
        this.languageChanged('en');
        console.log("浏览器语言是英文" + this.$i18n.locale);
      } else {
        // 浏览器语言是其它
        this.languageChanged('en');
        console.log("浏览器语言是其它");
      }
    },
    languageChanged(key) {
      this.$i18n.locale = key;
      this.$cookies.set("language", this.$i18n.locale);
    },
    browserDetection() {
      this.$notify({
        title: '提示',
        type: 'warning',
        offset: 40,
        dangerouslyUseHTMLString: true,
        message: '为了保证系统功能正常使用，建议您使用<a target=_blank href="https://www.google.cn/intl/zh-CN/chrome/">Chrome浏览器</a>最新版本进行访问!',
        duration: 0
      });
      false && setTimeout(() => {
        this.$notify({
          title: 'Kares 2.0上线!',
          type: 'success',
          dangerouslyUseHTMLString: true,
          message: `全新改版文件夹式素材管理、拖拽式的节目制作、
          多组合的节目发布（支持循环发布、定时发布、紧急插播）、从素材到节目再到发布多级审核机制，更多更新请登录体验。
          <a href="http://admin.kystarcloud.com/help">点击这里</a>
          图文视频说明带你快速上手。 因平台全面更新，数据库升级，原平台上的素材已清空，
          如需找回原素材或遇到新旧版本兼容性问题可联系 廖工17310602851(微信同号）`,
          duration: 0
        });
      });
      // setTimeout(() => {
      //   this.$notify({
      //     title: 'Kares 2.0上线!',
      //     type: 'success',
      //     dangerouslyUseHTMLString: true,
      //     message: `全新改版文件夹式素材管理、拖拽式的节目制作、
      //     多组合的节目发布（支持循环发布、定时发布、紧急插播）、
      //     从素材到节目再到发布多级审核机制，更多更新请登录体验。
      //     <a target=_blank href="http://admin.kystarcloud.com/help">点击这里</a>，图文视频说明带你快速上手。`,
      //     duration: 0
      //   });
      // });
    },
    async entrance() {
      // if (this.localhost !== "") {
      //   // eslint-disable-next-line no-unused-vars
      //   this.$http.post("/admin/nindex/verifyUrl", { url: `http://${this.localhost}` }, data => {
      //     this.historyLocalhost.findIndex((item) => item === this.localhost) === -1 ? this.historyLocalhost.push(this.localhost) : -1;
      //     localStorage.setItem("historyLocalhost", JSON.stringify(this.historyLocalhost));
      //     // window.location.replace(`http://${this.localhost}`);
      //   });
      // } else {
      //   this.$msg({ showClose: true, message: "请输入服务器地址！", type: 'warning' });
      // }
      await this.$http.postCustom("/api/admin/nindex/verifyUrl", { url: `http://${this.localhost}` }, async () => {
        // 检测当前输入的地址是否在历史记录中存在，如果存在就将它移动到数组的第一个，如果没有就将它添加到第一个
        let isHistory = this.historyLocalhost.findIndex((item) => item === this.localhost);
        if (isHistory === -1) {
          // 添加到第一个
          this.historyLocalhost.unshift(this.localhost);
        } else {
          // 将历史地址移动到第一个
          this.historyLocalhost.unshift(this.historyLocalhost.splice(isHistory, 1)[0]);
        }

        // 将所有历史地址缓存到本地
        localStorage.setItem("historyLocalhost", JSON.stringify(this.historyLocalhost));

        //将本地地址同步到当前服务器
        await this.$http.postCustom("/admin/nindex/urlSynchronize", {
          url_list: encodeURIComponent(JSON.stringify(this.historyLocalhost)),
          type: "update",
          mt_uuid: localStorage.getItem("uuid") || ""
        }, data => {
          localStorage.setItem("uuid", data.mt_uuid);
        }, false, false, `http://${this.localhost}:8081`);

        // 将所有本地地址同步到所有服务器
        await this.historyLocalhost.forEach((urlItem) => {
          this.$http.postCustom("/admin/nindex/urlSynchronize", {
            url_list: encodeURIComponent(JSON.stringify(this.historyLocalhost)),
            type: "update",
            mt_uuid: localStorage.getItem("uuid") || ""
          }, data => {
            console.log(data);
          }, false, false, `http://${urlItem}:8081`);
        });

        // 跳转到当前服务器
        await window.location.replace(`http://${this.localhost}/login?uuid=${localStorage.getItem("uuid")}`);

      }, false, false, `http://${this.localhost}`);

      //将本地地址同步到当前服务器
      // await this.$http.post("/admin/nindex/urlSynchronize", {
      //   url_list: encodeURIComponent(JSON.stringify(this.historyLocalhost)),
      //   type: "update",
      //   mt_uuid: localStorage.getItem("uuid") || ""
      // }, data => {
      //   localStorage.setItem("historyLocalhost", JSON.stringify(data.mt_urls));
      //   localStorage.setItem("uuid", data.mt_uuid);
      // });
      // 将所有本地地址同步到所有服务器
      // this.historyLocalhost.forEach((urlItem) => {
      //   this.$http.post("/admin/nindex/urlSynchronize", {
      //     url_list: encodeURIComponent(JSON.stringify(this.historyLocalhost)),
      //     type: "get",
      //     mt_uuid: localStorage.getItem("uuid") || ""
      //   }, data => {
      //     console.log(data);
      //   }, false, true, `http://${urlItem}`);
      // });

      // 跳转到当前服务器
      // await window.location.replace(`http://${this.localhost}`);

    },
    remHistoryLocalhost() {
      localStorage.removeItem("historyLocalhost");
      this.historyLocalhost = [];
    },
    // 进入修改服务器地址
    localhostEdit() {
      this.historyLocalhost = JSON.parse(localStorage.getItem("historyLocalhost")) || this.historyLocalhost;
      this.showType = 'host';
    },
    handleHistory(history) {
      this.localhost = history;
    },
    setShowType(showType = 'login') {
      this.showType = showType;
    },
    handleSubmit(formName) {
      // 如果记住密码没有勾选删除历史记住的密码
      !this.rtp && (localStorage.removeItem("userInfo") || false);
      !this.rtp && this.$cookies.set("rtp", '-1');
      // 记住密码七天
      this.rtp && (this.$cookies.get("rtp") !== '1') && this.$cookies.set("rtp", '1', '7d');
      this.rtp && localStorage.setItem("userInfo", JSON.stringify(this.loginForm));

      this.$refs[formName].validate(valid => {
        if (valid || !this.showVerify) {
          let extraData = { _t: this.verifyT };
          let loginForm = Object.assign(this.loginForm, extraData);
          this.handleLogin(loginForm);
          this.refreshCode();
        } else {
          console.log("error submit!");
          return false;
        }
      });
    },
    async handleLogin(loginFormData) {
      await this.$http.post("/admin/nindex/login", loginFormData, data => {
        this.userIsLoginAndSetCookie(data);

        const { password } = this.loginForm;
        if (passwordStrength(password).strength < 3) {
          this.showType = 'editPd';
          this.$cookies.set("isLogin", 0);
        } else {
          setTimeout(() => {
            this.$cookies.remove('verify');
            this.$router.push({ path: "/" });
            this.$router.go(0);
          }, 500);
        }
      });
      this.showVerify = parseInt(this.$cookies.get('verify')) >= 3;
    },
    refreshCode() {
      this.getRandom();
      this.verifyUrl = baseURL + VERIFY_URI;
      this.verifyUrl += "?_t=" + this.verifyT;
    },
    getRandom() {
      this.verifyT = new Date().getTime();
      this.verifyUrl = baseURL + VERIFY_URI + "?_t=" + this.verifyT;
    },
    showPassword() {
      if (this.pwdType === "password") {
        this.pwdType = "text";
        this.eyeType = "fa fa-eye fa-lg";
      } else {
        this.pwdType = "password";
        this.eyeType = "fa fa-eye-slash fa-lg";
      }
    },
    userIsLoginAndSetCookie(info) {
      let hasNode = JSON.parse(info.hasNode);
      // console.log(info);
      info.systermMemory && info.systermMemory.forEach((sm) => {
        let value = sm.replace(/\s+/g, " ").split(" ");
        if (value[5] === '/') {
          this.$cookies.set("systemMemory", value[4])
        }
        if (value[5] === '/data') {
          this.$cookies.set("dataMemory", value[4])
        }
      })

      // console.log(parseInt(this.$cookies.get("systemMemory")));
      // this.$cookies.config(2 * 60 * 60, ''); // 1小时后过期，以秒为单位
      this.$cookies.config(info.timeouts, ''); // 1小时后过期，以秒为单位
      this.$cookies.set("user_id", info.id)
        .set("isadmin", info.isadmin)
        .set("role_id", info.role_id)
        .set("username", info.name)
        .set("realname", info.realname)
        .set("isLogin", 1)
        .set("token", info.token)
        .set("group_id", info.group_id)
        .set("user_level", info.user_level)
        .set("user_pid", info.user_pid)
        .set("accessRoleList", hasNode.roleList)
        .set("accessGroupList", hasNode.groupList)
        .set("accessUserRelationship", hasNode.userRelationship)
        .set("accessCheck", hasNode.check)
        .set("priority", info.priority)
        .set("showHelp", false);
    }
  }
};
</script>
<style>
.el-form-item {
  margin-bottom: 0px;
}
.el-form-item + .el-form-item {
  margin-top: 25px;
}
.el-input__inner {
  border-radius: 20px;
  padding-left: 20px;
}
.el-form-item__error {
  padding-left: 20px;
}
.el-button {
  width: 100%;
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#dddddd, #dddddd);
  background-blend-mode: normal, normal;
  border-color: #86eae7;
}
.el-button:hover {
  background-image: linear-gradient(
      270deg,
      #57e4e0 0%,
      #2cb8de 45%,
      #008bdb 100%
    ),
    linear-gradient(#dddddd, #dddddd);
  background-blend-mode: normal, normal;
  border-color: #86eae7;
}
</style>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../assets/images/login/bg_logo.png") no-repeat center center;
  // position: relative;
  .login-localhost {
    width: 100%;
    height: 100%;
    // position: fixed;
    // top: 0;
    // left: 0;
    // z-index: 999;
    background: #edfbff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .exit {
      padding: 6px;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 32px;
      color: #ff8739;
    }
    .localhost-input {
      display: flex;
      height: 40px;
      /deep/ .el-input__inner {
        border-radius: 4px;
      }
      .localhost-input-item + .localhost-input-item {
        margin-left: 12px;
      }
    }
    .localhost-status {
      margin-top: 12px;
      width: 382px;
      div + div {
        margin-top: 12px;
        .l-h-list {
          height: 30px;
          line-height: 30px;
        }
        .l-h-list:active {
          background-color: #e5f9fd;
        }
      }
    }
  }
  .animation-enter-active {
    transition: opacity 0.5s;
  }
  .animation-leave-active {
    transition: opacity 0;
  }
  .animation-enter,
  .animation-leave-to {
    opacity: 0;
  }
  .login {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .language {
      height: 40px;
      position: absolute;
      right: 16px;
      top: 0px;
      .language-icon {
        width: 20px;
        height: 20px;
      }
      div {
        cursor: pointer;
      }
    }
    .record-n-varchar {
      height: 40px;
      position: absolute;
      bottom: 0px;
      a {
        color: #bbb;
        text-decoration: none;
      }
      a:hover {
        color: #000;
      }
    }
  }
  .login-main {
    width: 820px;
    height: 470px;
    border-radius: 8px;
    display: flex;
    background-color: #fff;
  }
  .main-left {
    width: 460px;
    border-radius: 8px 0 0 8px;
    overflow: hidden;
    img {
      width: 460px;
      height: 470px;
    }
  }
  .main-right {
    width: 360px;
    height: 470px;
    border-radius: 0 8px 8px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-form {
      width: 274px;
      .form-login {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .form-verify {
        .verify {
          display: flex;
          .verify-code {
            height: 40px;
            .identifyimg {
              margin-left: 4px;
              width: 135px;
              height: 40px;
              border-radius: 20px;
            }
          }
        }
      }
      .login-img {
        width: 200px;
        height: 50px;
      }
    }
    .register {
      text-align: center;
      color: #606266;
      span {
        cursor: pointer;
        user-select: none;
      }
      i {
        user-select: none;
      }
      span:hover {
        color: #000;
      }
    }
    .form-rtp {
      display: flex;
      justify-content: space-between;
      span {
        color: #2fb3ff;
      }
    }
  }
}
</style>
